function findDominantEnergy(results) {
      if (!results || !Array.isArray(results) || results.length === 0) {
        return '';
      }
    
      // Count occurrences of each energy type with special rules
      const energyCounts = {};
      
      // First pass: Initialize and count basic occurrences
      results.forEach((result, index) => {
        if (result && result.originalEnergy) {
          const baseEnergy = result.originalEnergy;
          
          // Initialize count if not exists
          if (!energyCounts[baseEnergy]) {
            energyCounts[baseEnergy] = {
              count: 0,
              hasAdjacentOccurrences: false,
              lastPosition: '0-0',
              hasNumberFive: false,
              isFollowedByPhucVi: false
            };
          }

          // Increment base count
          energyCounts[baseEnergy].count += 1;
          
          // Update last position
          energyCounts[baseEnergy].lastPosition = result.position || '0-0';
          
          // Check for number 5 or 0
          if (result.number?.includes('5') || result.number?.includes('0')) {
            energyCounts[baseEnergy].hasNumberFive = true;
            
            // Initialize Phuc Vi count if not exists
            if (!energyCounts['Phục vị']) {
              energyCounts['Phục vị'] = {
                count: 0,
                hasAdjacentOccurrences: false,
                lastPosition: '0-0',
                hasNumberFive: false,
                isFollowedByPhucVi: false
              };
            }
            // Add bonus count to Phuc Vi when other energies have 5 or 0
            if (baseEnergy !== 'Phục vị') {
              energyCounts['Phục vị'].count += 1;
            }
          }

          // Check for adjacent occurrences
          if (index < results.length - 1 && 
              results[index + 1]?.originalEnergy === baseEnergy) {
            energyCounts[baseEnergy].hasAdjacentOccurrences = true;
          }
        }
      });
    
      // Second pass: Check for Phuc Vi following relationships
      results.forEach((result, index) => {
        if (result && result.originalEnergy && index < results.length - 1) {
          const baseEnergy = result.originalEnergy;
          const nextEnergy = results[index + 1]?.originalEnergy;

          if (nextEnergy === 'Phục vị') {
            energyCounts[baseEnergy].isFollowedByPhucVi = true;
            energyCounts[baseEnergy].count += 1; // Bonus count for being followed by Phuc Vi
            energyCounts[baseEnergy].hasAdjacentOccurrences = true; // Consider as adjacent
          }
        }
      });
    
      // Convert to array for sorting
      const energyDetails = Object.entries(energyCounts).map(([energy, details]) => ({
        energy,
        ...details
      }));
    
      // Sort by count first, then prioritize last position
      energyDetails.sort((a, b) => {
        // First priority: total count (including bonuses)
        if (a.count !== b.count) {
          return b.count - a.count;
        }
    
        // When counts are equal, prioritize the energy that appears last
        const posA = parseInt(a.lastPosition.split('-')[1]);
        const posB = parseInt(b.lastPosition.split('-')[1]);
        return posB - posA;
      });
    
      return energyDetails.length > 0 ? energyDetails[0].energy : null;
    }
    
    export default findDominantEnergy;
